import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import ActionButton from 'client/components/Result/Actions/ActionButton';
import { setTextVariantStyle } from 'utils/variantStyle';

const ViewResultButton = ({ onClick, btnStyle = '', disabled, isLoading }) => {
    const { viewResultButtonText } = useSelector(s => s.settingPromo);
    return (
        <ActionButton
            text={viewResultButtonText || i18n.t('label.view_result_button_text')}
            onClick={onClick}
            btnStyle={buttonStyle(btnStyle)}
            disabled={disabled}
            isLoading={isLoading}
        />
    );
};

ViewResultButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    btnStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool
};

export default ViewResultButton;

const buttonStyle = btnStyle => css`
    ${btnStyle}
    padding: 14px 22px;
    border-radius: 100px;
    & .MuiTypography-root {
        ${setTextVariantStyle('button')}
    }
`;
